import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_AKTION_BEARBEITEN_BERECHTIGUNG = '[VeranstaltungenModul] GetAktionBearbeitenBerechtigung laden';
export const GET_AKTION_BEARBEITEN_BERECHTIGUNG_AUSFUEHREN = '[VeranstaltungenModul] GetAktionBearbeitenBerechtigung ausführen';
export const GET_AKTION_BEARBEITEN_BERECHTIGUNG_ERFOLGREICH = '[VeranstaltungenModul] GetAktionBearbeitenBerechtigung laden erfolgreich';
export const GET_AKTION_BEARBEITEN_BERECHTIGUNG_FEHLER = '[VeranstaltungenModul] GetAktionBearbeitenBerechtigung Ladefehler';
export const GET_AKTION_BEARBEITEN_BERECHTIGUNG_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetAktionBearbeitenBerechtigung nicht ausgeführt (evtl. Offline)';


export class GetAktionBearbeitenBerechtigungAction implements Action {
    readonly type = GET_AKTION_BEARBEITEN_BERECHTIGUNG;
        constructor( public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetAktionBearbeitenBerechtigungAusfuehrenAction implements Action {
    readonly type = GET_AKTION_BEARBEITEN_BERECHTIGUNG_AUSFUEHREN;
        constructor( public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetAktionBearbeitenBerechtigungErfolgreichAction implements Action {
    readonly type = GET_AKTION_BEARBEITEN_BERECHTIGUNG_ERFOLGREICH;
        constructor(public payload: api.AktionBearbeitenBerechtigungen,  public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetAktionBearbeitenBerechtigungFehlerAction implements Action {
    readonly type = GET_AKTION_BEARBEITEN_BERECHTIGUNG_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetAktionBearbeitenBerechtigungNichtAusgefuehrtAction implements Action {
    readonly type = GET_AKTION_BEARBEITEN_BERECHTIGUNG_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryAktionBearbeitenBerechtigungActions =
    GetAktionBearbeitenBerechtigungAction
    | GetAktionBearbeitenBerechtigungAusfuehrenAction
    | GetAktionBearbeitenBerechtigungErfolgreichAction
    | GetAktionBearbeitenBerechtigungFehlerAction
    | GetAktionBearbeitenBerechtigungNichtAusgefuehrtAction
    ;
